/**
 * Determines whether validation should be skipped for the widget,
 * typically used in modal child contexts.
 *
 * @param {WidgetProps<any, any>} props - The widget properties.
 * @returns {boolean} - `true` if validation should be skipped, otherwise `false`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSkipValidate(props) {
    return props.internalData.modalChildSkipValidate;
}
